<template>
  <div class="category-modal-container">
    <el-dialog title="选择分类" :visible.sync="dialogVisible">
      <ul class="category-list-wrap clearfix">
        <li v-for="(item,index) in categoryList" :class="{'is-info':item.isSelected}" class="is-outlined fleft button" @click="categorySelect(index)">{{item.categoryName}}・{{item.count}}</li>
      </ul>
      <div class="category-input-wrap tile">
        <input type="text" v-model="inputCategoryName">
        <button class="button is-info add-category" @click="addCategory">添加</button>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="MODAL_OK_EVENT">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script type="text/babel">
  import Vue from 'vue';

  export default {
    data(){
      return {
        categoryList:[],
        categorySelectList:[],//选中的分类集合
        inputCategoryName:"",//输入的自定义分类
        dialogVisible:false
      }
    },
    props:{
      itemCategorylist:{
        type:[Object,Array],
        default:null
      },
      item: {
        type: [Object],
        default: null
      }
    },
    created() {
    },
    methods: {
      showModal(){
        this.dialogVisible = true;
        this.getCategoryList();
      },
      //确认
      MODAL_OK_EVENT(){
        let selectedCategories = []
        this.categorySelectList = []
        _.each(this.categoryList,(item,index)=>{
          if(item.isSelected == true){
            this.categorySelectList.push(item.categoryId);
            selectedCategories.push(item)
          }
        })
        let params = Object.assign({type: 1}, this.item, {categoryIds: this.categorySelectList.length == 0 ? [0] : this.categorySelectList})
        HttpRequest.post('/admin.php?method=wechat.subscribe', params, true).then((response) => {
          this.accountList = response.data.list;
          this.dialogVisible = false;
        })
        this.$emit("update-category-event", selectedCategories)
      },
      //获取所有分类
      getCategoryList(){
        HttpRequest.post('/admin.php?method=wechat.getAccountCategory', true).then((response) => {
          let data = response.data
          _.each(data, (item, index)=> {
            _.each(this.itemCategorylist, (value)=> {
              if (item.categoryId == value.categoryId) {
                item.isSelected = true
              }
            })
          })
          this.categoryList = _.toArray(data)
        })
      },
      //分类选中
      categorySelect(index){
        if(this.categoryList[index].isSelected === undefined || this.categoryList[index].isSelected == false){//未选中,标记选中
          Vue.set(this.categoryList[index], 'isSelected', true)
        } else {
          Vue.set(this.categoryList[index], 'isSelected', false)
        }
      },
      //新增分类
      addCategory(){
        if(!this.inputCategoryName){
          this.$message("请输入分类名称!");
          return false
        }
        let params = {
          categoryId: 0,
          isSelected: true,
          categoryName: this.inputCategoryName
        }
        HttpRequest.post('/admin.php?method=wechat.updateCategory', params, true).then((response) => {
          if (response.data.success) {
            let item = {
              categoryId:response.data.categoryId,
              categoryName:this.inputCategoryName,
              count:0,
              isSelected:true
            }
            this.categoryList.push(item)
            this.inputCategoryName = "";
          }
        })
      }
    }
  }
</script>
<style lang="less">
 .category-modal-container{
    .category-list-wrap{
      height: 300px;
      display: inline-block;
      li{
        cursor: pointer;
        margin: 0 12px 15px 0;
      }
    }
   .category-input-wrap{
     .add-category{
       margin-left: 20px;
     }
   }

 }
</style>
